import { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { useUser } from "src/atoms/user";
import { pages } from "src/utils";
import { useNavigation } from "src/utils/navigation";
import { deleteRedirectUrl, getSafeRedirectUrl } from "src/utils/sessionStorage";

export const IsUnauthorized = () => {
  const { user } = useUser();
  const { navigate } = useNavigation();

  // Soon as user logs in, redirect.
  useEffect(() => {
    if (user) {
      navigate(getSafeRedirectUrl() || pages.home);
      deleteRedirectUrl();
    }
  }, [user]);

  return user ? null : <Outlet />;
};
